module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumbBlurSmall/shoals.a6489da.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumbBlurSmall/shoals.jpg
// module id = M9hV
// module chunks = 0